module.exports = __webpack_public_path__ + "static/media/mksu_logo2.6c31d866.png";